/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { HStack, Spacer } from '@chakra-ui/react';
import { Buffer } from 'buffer';
import { type FC, useMemo } from 'react';
import { type Request } from '../../interface/Crash';
import { Code } from '../Code';
import { FakeRequestButton } from './FakeRequestButton';
import { OpenResponseInTabButton } from './OpenResponseInTabButton';

export const ResponseBodyView: FC<{
    request: Request;
    reportKind: 'crash' | 'protocol';
    reportId: string;
    requestId: number;
}> = ({ request, reportKind, reportId, requestId }) => {
    const responseBody = request.response?.body ?? request.response?.result;
    const responseBodyBytes = responseBody?.bytes;
    const mime = responseBody?.content_type;

    const decodedBody = useMemo(() => {
        if (!responseBodyBytes) return null;
        if (mime?.startsWith('image/')) return null;
        return Buffer.from(responseBodyBytes, 'base64').toString();
    }, [responseBodyBytes, mime]);

    if (!responseBodyBytes) {
        return <>Empty Body</>;
    }
    if (mime?.startsWith('image/')) {
        return (
            <HStack>
                <img src={`data:${mime};base64,${responseBodyBytes}`} alt="response preview" />
            </HStack>
        );
    }
    return (
        <>
            <HStack>
                <Spacer />
                <FakeRequestButton request={request} kind={reportKind} reportId={reportId} requestId={requestId} />
                <OpenResponseInTabButton kind={reportKind} reportId={reportId} requestId={requestId} />
            </HStack>
            <CopyableCodeBlock text={decodedBody ?? ''} />
        </>
    );
};

export const CopyableCodeBlock: FC<{ text: string }> = ({ text }) => {
    return (
        <Code wrapWhiteSpace={true} mt={5} p={3} textToCopy={text}>
            {text}
        </Code>
    );
};
